import styled from 'styled-components';

export const MessageContainer = styled.div`
  background-color: #f7fafc;
  background-image: url(img/map.png);
  padding-bottom: 100px;
  padding-top: 30px;

  .description {
    p,
    h2 {
      color: #212529;
    }

    padding: 50px 0;
    margin: auto;
    width: 80%;
    text-align: center;
  }

  .contact-form {
    width: 80%;
    max-width: 800px;
    margin: auto;

    .col-sm {
      margin-top: 15px;
    }
  }

  button {
    background: #114b8b;
    border-color: #8ca0b5;
  }
`;
